export default "__VITE_ASSET__Z1qYdHBM__"